import React, { useEffect, useState } from 'react'
import { IFormStatus, ISubscribeProps } from './types'
import { functions, useApp } from '@wap-client/core'
import { queryService } from '@wap-client/services'
import Spinner from '@/components/base/spinner'
import Icon from '@/components/base/icon'
import Link from 'next/link'
import useTranslations from '@/hooks/useTranslations'

const SubscribeV2: React.FC<ISubscribeProps> = () => {
  const app = useApp()
  const { translation } = useTranslations()
  const [email, setEmail] = useState<string>('')
  const [checkbox, setCheckbox] = useState<boolean>(false)
  const [formLoading, setFormLoading] = useState<boolean>(false)
  const [formStatus, setFormStatus] = useState<IFormStatus>('')

  const messages: { [K in IFormStatus]: string } = {
    success: translation('subscribe-success'),
    duplicate: translation('subscribe-duplicate'),
    error: translation('subscribe-error'),
    '': '',
  }

  const handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault()
    setFormLoading(true)

    queryService
      .create(
        app.environment,
        {
          name: 'create-app-newsletter',
          language: app.language,
        },
        {
          columns: [
            {
              name: 'email',
              data: {
                refs: [],
                value: email,
              },
            },
            {
              name: 'baslik',
              data: {
                refs: [],
                value: 'Abone',
              },
            },
          ],
        },
      )
      .then(() => {
        setFormStatus('success')
      })
      .catch((error) => {
        console.log(error)
        error?.code === 409
          ? setFormStatus('duplicate')
          : setFormStatus('error')
      })
      .finally(() =>
        setTimeout(() => {
          setFormLoading(false)
        }, 3000),
      )
  }

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>

    const resetForm = () => {
      setEmail('')
      setCheckbox(false)
      timeoutId = setTimeout(() => {
        setFormStatus('')
      }, 3000)
    }

    switch (formStatus) {
      case 'success':
        resetForm()
        break
      case 'duplicate':
        timeoutId = setTimeout(() => {
          setFormStatus('')
        }, 3000)
        break
      case 'error':
        resetForm()
        break
      default:
        break
    }

    return () => {
      clearTimeout(timeoutId)
    }
  }, [formStatus])

  return (
    <div className="subscribe-v2">
      <div className="subscribe-v2-header">
        <span className="subscribe-v2-header-title">
          {translation('subscribe-title')}
        </span>
        <span className="subscribe-v2-header-desc">
          {translation('subscribe-desc')}
        </span>
      </div>
      <form className="subscribe-v2-form" onSubmit={handleSubmit}>
        <div className="subscribe-v2-form-input">
          <input
            className="subscribe-v2-form-input-mail-input"
            type="email"
            required
            placeholder={translation('subscribe-input-placeholder')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={formLoading}
          />
          <button
            className={functions.classnames(
              'subscribe-v2-form-input-submit-button',
              formLoading && 'loading',
            )}
            type="submit"
            disabled={!checkbox}
          >
            {formLoading ? (
              <div className="subscribe-v2-form-input-submit-button-loading">
                <Spinner size="small" color="white" />
                {translation('loading')}
              </div>
            ) : (
              translation('subscribe')
            )}
          </button>
          <div
            className={functions.classnames(
              'subscribe-v2-loading-message',
              formStatus !== '' ? `show ${formStatus}` : 'hidden',
            )}
          >
            {formStatus !== '' && (
              <Icon
                name={formStatus === 'success' ? 'check-circle' : 'warning'}
                size="small"
              />
            )}

            <span>
              {messages[formStatus]?.length >= 47
                ? messages[formStatus]?.slice(0, 44) + '...'
                : messages[formStatus]}
            </span>
          </div>
        </div>
        <label className="subscribe-v2-form-checkbox">
          <div className="subscribe-v2-form-checkbox-input-layout">
            <input
              type="checkbox"
              checked={checkbox}
              name="Clarification Text Checkbox Button"
              required
              onChange={(e) => setCheckbox(!checkbox)}
            />
          </div>
          <p className="subscribe-v2-form-checkbox-text">
            {translation('subscribe-checkbox-text')}
            <Link
              href="https://goturkiye.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              {translation('subscribe-checkbox-clarification-text')}
            </Link>
          </p>
        </label>
      </form>
    </div>
  )
}

export default SubscribeV2
